import React from 'react';

const AdvancedSearchIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 28 34"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={className}
    >
      <defs>
        <path
          d="M19.6895606,18.1939006 L14.1489584,12.6518698 C16.6584424,9.35221348 16.1828179,4.67192824 13.0608791,1.94484899 C9.93894032,-0.782230261 5.23843133,-0.623406525 2.30759275,2.30818775 C-0.623245824,5.23978203 -0.782028619,9.94150301 1.94434765,13.0642468 C4.67072392,16.1869906 9.34980268,16.6627377 12.6486084,14.1526066 L18.1892107,19.6946374 C18.6065038,20.1017875 19.2722675,20.1017875 19.6895606,19.6946374 C20.1034798,19.2800585 20.1034798,18.6084796 19.6895606,18.1939006 Z M2.17925479,7.90689315 C2.17925479,4.74250977 4.7438331,2.17727019 7.90740077,2.17727019 C11.0709684,2.17727019 13.6355468,4.74250977 13.6355468,7.90689315 C13.6355468,11.0712765 11.0709684,13.6365161 7.90740077,13.6365161 C4.74538394,13.6327742 2.18299571,11.0697253 2.17925479,7.90689315 Z"
          id="path-1"
        ></path>
      </defs>
      <g id="UI-in-Progress" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="My_Tasks_Table" transform="translate(-536, -157)">
          <g id="table/basic/3-column" transform="translate(114, 136)">
            <g id="AdvSearch" transform="translate(422, 21)">
              <g id="search-copy" transform="translate(2, 9)">
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1"></use>
                </mask>
                <use id="icon-color" fill="#595959" xlinkHref="#path-1"></use>
              </g>
              <g id="plus" transform="translate(15.1667, 1.1667)" fill="#595959">
                <path
                  d="M5.83333333,-4.4408921e-16 C6.37027684,-4.4408921e-16 6.80555556,0.435278715 6.80555556,0.972222222 L6.80516667,4.86091667 L10.6944444,4.86111111 C11.231388,4.86111111 11.6666667,5.29638983 11.6666667,5.83333333 C11.6666667,6.37027684 11.231388,6.80555556 10.6944444,6.80555556 L6.80516667,6.80516667 L6.80555556,10.6944444 C6.80555556,11.231388 6.37027684,11.6666667 5.83333333,11.6666667 C5.29638983,11.6666667 4.86111111,11.231388 4.86111111,10.6944444 L4.86091667,6.80516667 L0.972222222,6.80555556 C0.435278715,6.80555556 -1.77635684e-15,6.37027684 -1.77635684e-15,5.83333333 C-1.77635684e-15,5.29638983 0.435278715,4.86111111 0.972222222,4.86111111 L4.86091667,4.86091667 L4.86111111,0.972222222 C4.86111111,0.435278715 5.29638983,-4.4408921e-16 5.83333333,-4.4408921e-16 Z"
                  id="icon-color"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default AdvancedSearchIcon;
